/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getCompanyAddressV2Book } from "api/services/company";
import { GetCompanyAddressV2BookResponseType } from "api/response"; // <-- import the correct type
import { companyQueryKeys } from "./companyQueryKeys";

export function useGetAddressesV2(
  params: any,
  options?: UseQueryOptions<any, unknown, GetCompanyAddressV2BookResponseType["results"], any>,
) {
  return useQuery<GetCompanyAddressV2BookResponseType["results"]>({
    queryKey: companyQueryKeys.addressesV2(params),
    queryFn: () => getCompanyAddressV2Book(params).then((res) => res.data.results),
    refetchOnMount: false,
    ...options,
  });
}
